import { FormEvent, useEffect, useRef } from "react";
import type { CurrentUser } from "../lib/types";
import { Icon } from "./Icon";

export function Topbar({
  query,
  onQuery,
  onSearch,
  loading,
  user,
  notice,
  onRefresh
}: {
  query: string;
  onQuery: (value: string) => void;
  onSearch: (value: string) => void;
  loading?: boolean;
  user: CurrentUser | null;
  notice?: string;
  onRefresh?: () => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function focusSearch(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    }

    window.addEventListener("keydown", focusSearch);
    return () => window.removeEventListener("keydown", focusSearch);
  }, []);

  function submit(event: FormEvent) {
    event.preventDefault();
    onSearch(inputRef.current?.value ?? query);
  }

  return (
    <header className="topbar">
      <form className="search-box" onSubmit={submit} role="search">
        <Icon name="search" />
        <input
          ref={inputRef}
          type="search"
          value={query}
          onChange={(event) => onQuery(event.target.value)}
          placeholder="Search clients, partners, nodes, city, stage..."
        />
        <button className="search-submit" type="submit" disabled={loading}>
          {loading ? "Loading" : "Search"}
        </button>
      </form>
      <div className="role-chip">
        <span>{user?.role === "worker" ? "User view" : "Owner view"}</span>
        <strong>{user?.email || "local preview"}</strong>
      </div>
      <div className="sync-status">
        <span className="health completed" />
        <span>{notice || "Backend ready"}</span>
      </div>
      <button className="icon-button" aria-label="Refresh workspace" onClick={onRefresh}>
        <Icon name="sync" />
      </button>
    </header>
  );
}
